export const FILE_TYPE_JPG = 'jpg';
export const FILE_TYPE_JPEG = 'jpeg';
export const FILE_TYPE_PNG = 'png';
export const FILE_TYPE_GIF = 'gif';
export const FILE_TYPE_MP4 = 'mp4';
export const FILE_TYPE_MOV = 'mov';
export const FILE_TYPE_WMV = 'wmv';
export const FILE_TYPE_PDF = 'pdf';
export const FILE_TYPE_WORD_DOC = 'doc';
export const FILE_TYPE_WORD_DOCX = 'docx';
export const FILE_TYPE_EXCEL_XLS = 'xls';
export const FILE_TYPE_EXCEL_XLSX = 'xlsx';

export const CONTENT_TYPE_JPG_JPEG = 'image/jpeg';
export const CONTENT_TYPE_PNG = 'image/png';
export const CONTENT_TYPE_GIF = 'image/gif';
export const CONTENT_TYPE_PDF = 'application/pdf';
export const CONTENT_TYPE_WORD_DOC = 'application/msword';
export const CONTENT_TYPE_WORD_DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
export const CONTENT_TYPE_EXCEL_XLS = 'application/excel';
export const CONTENT_TYPE_EXCEL_XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export const getFileExtension = (fileName: string): string => {
  return fileName.substr(fileName.lastIndexOf('.'));
}

export const getContentTypeByFilename = (fileName: string): string => {
  switch(getFileExtension(fileName)) {
  case FILE_TYPE_JPG:
  case FILE_TYPE_JPEG:
    return CONTENT_TYPE_JPG_JPEG;
  case FILE_TYPE_PNG:
    return CONTENT_TYPE_PNG;
  case FILE_TYPE_GIF:
    return CONTENT_TYPE_GIF;
  case FILE_TYPE_PDF:
    return CONTENT_TYPE_PDF;
  case FILE_TYPE_WORD_DOC:
    return CONTENT_TYPE_WORD_DOC;
  case FILE_TYPE_WORD_DOCX:
    return CONTENT_TYPE_WORD_DOCX;
  case FILE_TYPE_EXCEL_XLS:
    return CONTENT_TYPE_EXCEL_XLS;
  case FILE_TYPE_EXCEL_XLSX:
    return CONTENT_TYPE_EXCEL_XLSX;
  default:
    return '';
  }
}

/**
 * DownloadTrigger - Nome pomposo mas é só pra disfarçar
 * o grande _workaround_ que isso é...
 * @export
 * @param {string} fileName
 * @param {ArrayBuffer} data
 */
export default function (fileName: string, data: ArrayBuffer) {
  const blob = new Blob([data], {
    type: getContentTypeByFilename(fileName)
  });
  const href = window.URL.createObjectURL(blob);
  const trigger = document.createElement('a');
  trigger.setAttribute('download', fileName);
  trigger.setAttribute('href', href);
  trigger.click();
}
